import { memo } from 'react';

const Subs = ({ className }) => {
    return (
      <span className={className}>
             <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z'
                  stroke='currentColor' strokeWidth='1.5'/>
                <path
                  d='M17 2V11.8076C17 12.7825 17 13.27 16.8709 13.5607C16.5766 14.2233 15.8506 14.5805 15.1461 14.4095C14.8369 14.3344 14.4507 14.037 13.6782 13.4422C13.2421 13.1064 13.024 12.9385 12.797 12.8398C12.2886 12.619 11.7114 12.619 11.203 12.8398C10.976 12.9385 10.7579 13.1064 10.3218 13.4422C9.5493 14.037 9.16307 14.3344 8.85391 14.4095C8.14942 14.5805 7.42342 14.2233 7.12914 13.5607C7 13.27 7 12.7825 7 11.8076V2'
                  stroke='currentColor' strokeWidth='1.5'/>
                <path d='M17 18H7' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round'/>
            </svg>
        </span>
    );
};

export default memo(Subs);